module.exports = "/_next/static/images/ourParnersSpectrumLogo-d4566cd6b87afc3b78816557de38f201.webp";